/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as InitializedRouteImport } from './routes/_initialized'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InitializedWalletCreationOverviewRouteImport } from './routes/_initialized/walletCreationOverview'
import { Route as InitializedVerifyRosterMatchRouteImport } from './routes/_initialized/verifyRosterMatch'
import { Route as InitializedVerifyCardDetailsRouteImport } from './routes/_initialized/verifyCardDetails'
import { Route as InitializedTermsRouteImport } from './routes/_initialized/terms'
import { Route as InitializedSetMarqetaPinRouteImport } from './routes/_initialized/setMarqetaPin'
import { Route as InitializedPersonaRouteImport } from './routes/_initialized/persona'
import { Route as InitializedPasscodeRouteImport } from './routes/_initialized/passcode'
import { Route as InitializedKycResultsRouteImport } from './routes/_initialized/kycResults'
import { Route as InitializedBusinessAccountTypeSelectionRouteImport } from './routes/_initialized/businessAccountTypeSelection'
import { Route as InitializedBranchInformationalRouteImport } from './routes/_initialized/branchInformational'
import { Route as InitializedActivateExistingCardRouteImport } from './routes/_initialized/activateExistingCard'
import { Route as InitializedActivateCardRouteImport } from './routes/_initialized/activateCard'
import { Route as InitializedAccountTypeSelectionRouteImport } from './routes/_initialized/accountTypeSelection'
import { Route as InitializedAccountCreatedRouteImport } from './routes/_initialized/accountCreated'
import { Route as InitializedAddressIndexRouteImport } from './routes/_initialized/address/index'
import { Route as InitializedPhoneSignUpVerifyPinRouteImport } from './routes/_initialized/phone/signUpVerifyPin'
import { Route as InitializedPhoneSignInVerifyPinRouteImport } from './routes/_initialized/phone/signInVerifyPin'
import { Route as InitializedAddressAddressRecommendationRouteImport } from './routes/_initialized/address/addressRecommendation'
import { Route as InitializedAddressAddressPOBoxErrorRouteImport } from './routes/_initialized/address/addressPOBoxError'

const InitializedSsnLazyRouteImport = createFileRoute('/_initialized/ssn')()
const InitializedSingleSignOnLazyRouteImport = createFileRoute(
  '/_initialized/singleSignOn',
)()
const InitializedPostLoginExistingUserLazyRouteImport = createFileRoute(
  '/_initialized/postLoginExistingUser',
)()
const InitializedPayCardEducationLazyRouteImport = createFileRoute(
  '/_initialized/payCardEducation',
)()
const InitializedNoClaimLinkLazyRouteImport = createFileRoute(
  '/_initialized/noClaimLink',
)()
const InitializedNeedOrganizationLinkLazyRouteImport = createFileRoute(
  '/_initialized/needOrganizationLink',
)()
const InitializedNameOnCardLazyRouteImport = createFileRoute(
  '/_initialized/nameOnCard',
)()
const InitializedKycPendingLazyRouteImport = createFileRoute(
  '/_initialized/kycPending',
)()
const InitializedKycMinorLazyRouteImport = createFileRoute(
  '/_initialized/kycMinor',
)()
const InitializedKycFailedEssentialAvailableLazyRouteImport = createFileRoute(
  '/_initialized/kycFailedEssentialAvailable',
)()
const InitializedKycFailedLazyRouteImport = createFileRoute(
  '/_initialized/kycFailed',
)()
const InitializedFullNameLazyRouteImport = createFileRoute(
  '/_initialized/fullName',
)()
const InitializedExistingUserDecisionLazyRouteImport = createFileRoute(
  '/_initialized/existingUserDecision',
)()
const InitializedExistingCardDecisionLazyRouteImport = createFileRoute(
  '/_initialized/existingCardDecision',
)()
const InitializedEmailLazyRouteImport = createFileRoute('/_initialized/email')()
const InitializedConfirmPasscodeLazyRouteImport = createFileRoute(
  '/_initialized/confirmPasscode',
)()
const InitializedConfirmExitLazyRouteImport = createFileRoute(
  '/_initialized/confirmExit',
)()
const InitializedCompareAccountsLazyRouteImport = createFileRoute(
  '/_initialized/compareAccounts',
)()
const InitializedCoBrandedLandingSlidesLazyRouteImport = createFileRoute(
  '/_initialized/coBrandedLandingSlides',
)()
const InitializedCardLastFourLazyRouteImport = createFileRoute(
  '/_initialized/cardLastFour',
)()
const InitializedBirthDateLazyRouteImport = createFileRoute(
  '/_initialized/birthDate',
)()
const InitializedPhoneIndexLazyRouteImport = createFileRoute(
  '/_initialized/phone/',
)()
const InitializedPhoneSignInPhoneLazyRouteImport = createFileRoute(
  '/_initialized/phone/signInPhone',
)()
const InitializedPhoneExistingUserLazyRouteImport = createFileRoute(
  '/_initialized/phone/existingUser',
)()
const InitializedAddressAddressUpdateVerificationLazyRouteImport =
  createFileRoute('/_initialized/address/addressUpdateVerification')()
const InitializedAddressAddressSearchLazyRouteImport = createFileRoute(
  '/_initialized/address/addressSearch',
)()

const InitializedRoute = InitializedRouteImport.update({
  id: '/_initialized',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InitializedSsnLazyRoute = InitializedSsnLazyRouteImport.update({
  id: '/ssn',
  path: '/ssn',
  getParentRoute: () => InitializedRoute,
} as any).lazy(() =>
  import('./routes/_initialized/ssn.lazy').then((d) => d.Route),
)
const InitializedSingleSignOnLazyRoute =
  InitializedSingleSignOnLazyRouteImport.update({
    id: '/singleSignOn',
    path: '/singleSignOn',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/singleSignOn.lazy').then((d) => d.Route),
  )
const InitializedPostLoginExistingUserLazyRoute =
  InitializedPostLoginExistingUserLazyRouteImport.update({
    id: '/postLoginExistingUser',
    path: '/postLoginExistingUser',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/postLoginExistingUser.lazy').then(
      (d) => d.Route,
    ),
  )
const InitializedPayCardEducationLazyRoute =
  InitializedPayCardEducationLazyRouteImport.update({
    id: '/payCardEducation',
    path: '/payCardEducation',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/payCardEducation.lazy').then((d) => d.Route),
  )
const InitializedNoClaimLinkLazyRoute =
  InitializedNoClaimLinkLazyRouteImport.update({
    id: '/noClaimLink',
    path: '/noClaimLink',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/noClaimLink.lazy').then((d) => d.Route),
  )
const InitializedNeedOrganizationLinkLazyRoute =
  InitializedNeedOrganizationLinkLazyRouteImport.update({
    id: '/needOrganizationLink',
    path: '/needOrganizationLink',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/needOrganizationLink.lazy').then(
      (d) => d.Route,
    ),
  )
const InitializedNameOnCardLazyRoute =
  InitializedNameOnCardLazyRouteImport.update({
    id: '/nameOnCard',
    path: '/nameOnCard',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/nameOnCard.lazy').then((d) => d.Route),
  )
const InitializedKycPendingLazyRoute =
  InitializedKycPendingLazyRouteImport.update({
    id: '/kycPending',
    path: '/kycPending',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/kycPending.lazy').then((d) => d.Route),
  )
const InitializedKycMinorLazyRoute = InitializedKycMinorLazyRouteImport.update({
  id: '/kycMinor',
  path: '/kycMinor',
  getParentRoute: () => InitializedRoute,
} as any).lazy(() =>
  import('./routes/_initialized/kycMinor.lazy').then((d) => d.Route),
)
const InitializedKycFailedEssentialAvailableLazyRoute =
  InitializedKycFailedEssentialAvailableLazyRouteImport.update({
    id: '/kycFailedEssentialAvailable',
    path: '/kycFailedEssentialAvailable',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/kycFailedEssentialAvailable.lazy').then(
      (d) => d.Route,
    ),
  )
const InitializedKycFailedLazyRoute =
  InitializedKycFailedLazyRouteImport.update({
    id: '/kycFailed',
    path: '/kycFailed',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/kycFailed.lazy').then((d) => d.Route),
  )
const InitializedFullNameLazyRoute = InitializedFullNameLazyRouteImport.update({
  id: '/fullName',
  path: '/fullName',
  getParentRoute: () => InitializedRoute,
} as any).lazy(() =>
  import('./routes/_initialized/fullName.lazy').then((d) => d.Route),
)
const InitializedExistingUserDecisionLazyRoute =
  InitializedExistingUserDecisionLazyRouteImport.update({
    id: '/existingUserDecision',
    path: '/existingUserDecision',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/existingUserDecision.lazy').then(
      (d) => d.Route,
    ),
  )
const InitializedExistingCardDecisionLazyRoute =
  InitializedExistingCardDecisionLazyRouteImport.update({
    id: '/existingCardDecision',
    path: '/existingCardDecision',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/existingCardDecision.lazy').then(
      (d) => d.Route,
    ),
  )
const InitializedEmailLazyRoute = InitializedEmailLazyRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => InitializedRoute,
} as any).lazy(() =>
  import('./routes/_initialized/email.lazy').then((d) => d.Route),
)
const InitializedConfirmPasscodeLazyRoute =
  InitializedConfirmPasscodeLazyRouteImport.update({
    id: '/confirmPasscode',
    path: '/confirmPasscode',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/confirmPasscode.lazy').then((d) => d.Route),
  )
const InitializedConfirmExitLazyRoute =
  InitializedConfirmExitLazyRouteImport.update({
    id: '/confirmExit',
    path: '/confirmExit',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/confirmExit.lazy').then((d) => d.Route),
  )
const InitializedCompareAccountsLazyRoute =
  InitializedCompareAccountsLazyRouteImport.update({
    id: '/compareAccounts',
    path: '/compareAccounts',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/compareAccounts.lazy').then((d) => d.Route),
  )
const InitializedCoBrandedLandingSlidesLazyRoute =
  InitializedCoBrandedLandingSlidesLazyRouteImport.update({
    id: '/coBrandedLandingSlides',
    path: '/coBrandedLandingSlides',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/coBrandedLandingSlides.lazy').then(
      (d) => d.Route,
    ),
  )
const InitializedCardLastFourLazyRoute =
  InitializedCardLastFourLazyRouteImport.update({
    id: '/cardLastFour',
    path: '/cardLastFour',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/cardLastFour.lazy').then((d) => d.Route),
  )
const InitializedBirthDateLazyRoute =
  InitializedBirthDateLazyRouteImport.update({
    id: '/birthDate',
    path: '/birthDate',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/birthDate.lazy').then((d) => d.Route),
  )
const InitializedWalletCreationOverviewRoute =
  InitializedWalletCreationOverviewRouteImport.update({
    id: '/walletCreationOverview',
    path: '/walletCreationOverview',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/walletCreationOverview.lazy').then(
      (d) => d.Route,
    ),
  )
const InitializedVerifyRosterMatchRoute =
  InitializedVerifyRosterMatchRouteImport.update({
    id: '/verifyRosterMatch',
    path: '/verifyRosterMatch',
    getParentRoute: () => InitializedRoute,
  } as any)
const InitializedVerifyCardDetailsRoute =
  InitializedVerifyCardDetailsRouteImport.update({
    id: '/verifyCardDetails',
    path: '/verifyCardDetails',
    getParentRoute: () => InitializedRoute,
  } as any)
const InitializedTermsRoute = InitializedTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => InitializedRoute,
} as any).lazy(() =>
  import('./routes/_initialized/terms.lazy').then((d) => d.Route),
)
const InitializedSetMarqetaPinRoute =
  InitializedSetMarqetaPinRouteImport.update({
    id: '/setMarqetaPin',
    path: '/setMarqetaPin',
    getParentRoute: () => InitializedRoute,
  } as any)
const InitializedPersonaRoute = InitializedPersonaRouteImport.update({
  id: '/persona',
  path: '/persona',
  getParentRoute: () => InitializedRoute,
} as any)
const InitializedPasscodeRoute = InitializedPasscodeRouteImport.update({
  id: '/passcode',
  path: '/passcode',
  getParentRoute: () => InitializedRoute,
} as any)
const InitializedKycResultsRoute = InitializedKycResultsRouteImport.update({
  id: '/kycResults',
  path: '/kycResults',
  getParentRoute: () => InitializedRoute,
} as any)
const InitializedBusinessAccountTypeSelectionRoute =
  InitializedBusinessAccountTypeSelectionRouteImport.update({
    id: '/businessAccountTypeSelection',
    path: '/businessAccountTypeSelection',
    getParentRoute: () => InitializedRoute,
  } as any)
const InitializedBranchInformationalRoute =
  InitializedBranchInformationalRouteImport.update({
    id: '/branchInformational',
    path: '/branchInformational',
    getParentRoute: () => InitializedRoute,
  } as any)
const InitializedActivateExistingCardRoute =
  InitializedActivateExistingCardRouteImport.update({
    id: '/activateExistingCard',
    path: '/activateExistingCard',
    getParentRoute: () => InitializedRoute,
  } as any)
const InitializedActivateCardRoute = InitializedActivateCardRouteImport.update({
  id: '/activateCard',
  path: '/activateCard',
  getParentRoute: () => InitializedRoute,
} as any).lazy(() =>
  import('./routes/_initialized/activateCard.lazy').then((d) => d.Route),
)
const InitializedAccountTypeSelectionRoute =
  InitializedAccountTypeSelectionRouteImport.update({
    id: '/accountTypeSelection',
    path: '/accountTypeSelection',
    getParentRoute: () => InitializedRoute,
  } as any)
const InitializedAccountCreatedRoute =
  InitializedAccountCreatedRouteImport.update({
    id: '/accountCreated',
    path: '/accountCreated',
    getParentRoute: () => InitializedRoute,
  } as any)
const InitializedPhoneIndexLazyRoute =
  InitializedPhoneIndexLazyRouteImport.update({
    id: '/phone/',
    path: '/phone/',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/phone/index.lazy').then((d) => d.Route),
  )
const InitializedAddressIndexRoute = InitializedAddressIndexRouteImport.update({
  id: '/address/',
  path: '/address/',
  getParentRoute: () => InitializedRoute,
} as any)
const InitializedPhoneSignInPhoneLazyRoute =
  InitializedPhoneSignInPhoneLazyRouteImport.update({
    id: '/phone/signInPhone',
    path: '/phone/signInPhone',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/phone/signInPhone.lazy').then((d) => d.Route),
  )
const InitializedPhoneExistingUserLazyRoute =
  InitializedPhoneExistingUserLazyRouteImport.update({
    id: '/phone/existingUser',
    path: '/phone/existingUser',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/phone/existingUser.lazy').then(
      (d) => d.Route,
    ),
  )
const InitializedAddressAddressUpdateVerificationLazyRoute =
  InitializedAddressAddressUpdateVerificationLazyRouteImport.update({
    id: '/address/addressUpdateVerification',
    path: '/address/addressUpdateVerification',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/address/addressUpdateVerification.lazy').then(
      (d) => d.Route,
    ),
  )
const InitializedAddressAddressSearchLazyRoute =
  InitializedAddressAddressSearchLazyRouteImport.update({
    id: '/address/addressSearch',
    path: '/address/addressSearch',
    getParentRoute: () => InitializedRoute,
  } as any).lazy(() =>
    import('./routes/_initialized/address/addressSearch.lazy').then(
      (d) => d.Route,
    ),
  )
const InitializedPhoneSignUpVerifyPinRoute =
  InitializedPhoneSignUpVerifyPinRouteImport.update({
    id: '/phone/signUpVerifyPin',
    path: '/phone/signUpVerifyPin',
    getParentRoute: () => InitializedRoute,
  } as any)
const InitializedPhoneSignInVerifyPinRoute =
  InitializedPhoneSignInVerifyPinRouteImport.update({
    id: '/phone/signInVerifyPin',
    path: '/phone/signInVerifyPin',
    getParentRoute: () => InitializedRoute,
  } as any)
const InitializedAddressAddressRecommendationRoute =
  InitializedAddressAddressRecommendationRouteImport.update({
    id: '/address/addressRecommendation',
    path: '/address/addressRecommendation',
    getParentRoute: () => InitializedRoute,
  } as any)
const InitializedAddressAddressPOBoxErrorRoute =
  InitializedAddressAddressPOBoxErrorRouteImport.update({
    id: '/address/addressPOBoxError',
    path: '/address/addressPOBoxError',
    getParentRoute: () => InitializedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accountCreated': typeof InitializedAccountCreatedRoute
  '/accountTypeSelection': typeof InitializedAccountTypeSelectionRoute
  '/activateCard': typeof InitializedActivateCardRoute
  '/activateExistingCard': typeof InitializedActivateExistingCardRoute
  '/branchInformational': typeof InitializedBranchInformationalRoute
  '/businessAccountTypeSelection': typeof InitializedBusinessAccountTypeSelectionRoute
  '/kycResults': typeof InitializedKycResultsRoute
  '/passcode': typeof InitializedPasscodeRoute
  '/persona': typeof InitializedPersonaRoute
  '/setMarqetaPin': typeof InitializedSetMarqetaPinRoute
  '/terms': typeof InitializedTermsRoute
  '/verifyCardDetails': typeof InitializedVerifyCardDetailsRoute
  '/verifyRosterMatch': typeof InitializedVerifyRosterMatchRoute
  '/walletCreationOverview': typeof InitializedWalletCreationOverviewRoute
  '/birthDate': typeof InitializedBirthDateLazyRoute
  '/cardLastFour': typeof InitializedCardLastFourLazyRoute
  '/coBrandedLandingSlides': typeof InitializedCoBrandedLandingSlidesLazyRoute
  '/compareAccounts': typeof InitializedCompareAccountsLazyRoute
  '/confirmExit': typeof InitializedConfirmExitLazyRoute
  '/confirmPasscode': typeof InitializedConfirmPasscodeLazyRoute
  '/email': typeof InitializedEmailLazyRoute
  '/existingCardDecision': typeof InitializedExistingCardDecisionLazyRoute
  '/existingUserDecision': typeof InitializedExistingUserDecisionLazyRoute
  '/fullName': typeof InitializedFullNameLazyRoute
  '/kycFailed': typeof InitializedKycFailedLazyRoute
  '/kycFailedEssentialAvailable': typeof InitializedKycFailedEssentialAvailableLazyRoute
  '/kycMinor': typeof InitializedKycMinorLazyRoute
  '/kycPending': typeof InitializedKycPendingLazyRoute
  '/nameOnCard': typeof InitializedNameOnCardLazyRoute
  '/needOrganizationLink': typeof InitializedNeedOrganizationLinkLazyRoute
  '/noClaimLink': typeof InitializedNoClaimLinkLazyRoute
  '/payCardEducation': typeof InitializedPayCardEducationLazyRoute
  '/postLoginExistingUser': typeof InitializedPostLoginExistingUserLazyRoute
  '/singleSignOn': typeof InitializedSingleSignOnLazyRoute
  '/ssn': typeof InitializedSsnLazyRoute
  '/address/addressPOBoxError': typeof InitializedAddressAddressPOBoxErrorRoute
  '/address/addressRecommendation': typeof InitializedAddressAddressRecommendationRoute
  '/phone/signInVerifyPin': typeof InitializedPhoneSignInVerifyPinRoute
  '/phone/signUpVerifyPin': typeof InitializedPhoneSignUpVerifyPinRoute
  '/address/addressSearch': typeof InitializedAddressAddressSearchLazyRoute
  '/address/addressUpdateVerification': typeof InitializedAddressAddressUpdateVerificationLazyRoute
  '/phone/existingUser': typeof InitializedPhoneExistingUserLazyRoute
  '/phone/signInPhone': typeof InitializedPhoneSignInPhoneLazyRoute
  '/address': typeof InitializedAddressIndexRoute
  '/phone': typeof InitializedPhoneIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accountCreated': typeof InitializedAccountCreatedRoute
  '/accountTypeSelection': typeof InitializedAccountTypeSelectionRoute
  '/activateCard': typeof InitializedActivateCardRoute
  '/activateExistingCard': typeof InitializedActivateExistingCardRoute
  '/branchInformational': typeof InitializedBranchInformationalRoute
  '/businessAccountTypeSelection': typeof InitializedBusinessAccountTypeSelectionRoute
  '/kycResults': typeof InitializedKycResultsRoute
  '/passcode': typeof InitializedPasscodeRoute
  '/persona': typeof InitializedPersonaRoute
  '/setMarqetaPin': typeof InitializedSetMarqetaPinRoute
  '/terms': typeof InitializedTermsRoute
  '/verifyCardDetails': typeof InitializedVerifyCardDetailsRoute
  '/verifyRosterMatch': typeof InitializedVerifyRosterMatchRoute
  '/walletCreationOverview': typeof InitializedWalletCreationOverviewRoute
  '/birthDate': typeof InitializedBirthDateLazyRoute
  '/cardLastFour': typeof InitializedCardLastFourLazyRoute
  '/coBrandedLandingSlides': typeof InitializedCoBrandedLandingSlidesLazyRoute
  '/compareAccounts': typeof InitializedCompareAccountsLazyRoute
  '/confirmExit': typeof InitializedConfirmExitLazyRoute
  '/confirmPasscode': typeof InitializedConfirmPasscodeLazyRoute
  '/email': typeof InitializedEmailLazyRoute
  '/existingCardDecision': typeof InitializedExistingCardDecisionLazyRoute
  '/existingUserDecision': typeof InitializedExistingUserDecisionLazyRoute
  '/fullName': typeof InitializedFullNameLazyRoute
  '/kycFailed': typeof InitializedKycFailedLazyRoute
  '/kycFailedEssentialAvailable': typeof InitializedKycFailedEssentialAvailableLazyRoute
  '/kycMinor': typeof InitializedKycMinorLazyRoute
  '/kycPending': typeof InitializedKycPendingLazyRoute
  '/nameOnCard': typeof InitializedNameOnCardLazyRoute
  '/needOrganizationLink': typeof InitializedNeedOrganizationLinkLazyRoute
  '/noClaimLink': typeof InitializedNoClaimLinkLazyRoute
  '/payCardEducation': typeof InitializedPayCardEducationLazyRoute
  '/postLoginExistingUser': typeof InitializedPostLoginExistingUserLazyRoute
  '/singleSignOn': typeof InitializedSingleSignOnLazyRoute
  '/ssn': typeof InitializedSsnLazyRoute
  '/address/addressPOBoxError': typeof InitializedAddressAddressPOBoxErrorRoute
  '/address/addressRecommendation': typeof InitializedAddressAddressRecommendationRoute
  '/phone/signInVerifyPin': typeof InitializedPhoneSignInVerifyPinRoute
  '/phone/signUpVerifyPin': typeof InitializedPhoneSignUpVerifyPinRoute
  '/address/addressSearch': typeof InitializedAddressAddressSearchLazyRoute
  '/address/addressUpdateVerification': typeof InitializedAddressAddressUpdateVerificationLazyRoute
  '/phone/existingUser': typeof InitializedPhoneExistingUserLazyRoute
  '/phone/signInPhone': typeof InitializedPhoneSignInPhoneLazyRoute
  '/address': typeof InitializedAddressIndexRoute
  '/phone': typeof InitializedPhoneIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_initialized': typeof InitializedRouteWithChildren
  '/_initialized/accountCreated': typeof InitializedAccountCreatedRoute
  '/_initialized/accountTypeSelection': typeof InitializedAccountTypeSelectionRoute
  '/_initialized/activateCard': typeof InitializedActivateCardRoute
  '/_initialized/activateExistingCard': typeof InitializedActivateExistingCardRoute
  '/_initialized/branchInformational': typeof InitializedBranchInformationalRoute
  '/_initialized/businessAccountTypeSelection': typeof InitializedBusinessAccountTypeSelectionRoute
  '/_initialized/kycResults': typeof InitializedKycResultsRoute
  '/_initialized/passcode': typeof InitializedPasscodeRoute
  '/_initialized/persona': typeof InitializedPersonaRoute
  '/_initialized/setMarqetaPin': typeof InitializedSetMarqetaPinRoute
  '/_initialized/terms': typeof InitializedTermsRoute
  '/_initialized/verifyCardDetails': typeof InitializedVerifyCardDetailsRoute
  '/_initialized/verifyRosterMatch': typeof InitializedVerifyRosterMatchRoute
  '/_initialized/walletCreationOverview': typeof InitializedWalletCreationOverviewRoute
  '/_initialized/birthDate': typeof InitializedBirthDateLazyRoute
  '/_initialized/cardLastFour': typeof InitializedCardLastFourLazyRoute
  '/_initialized/coBrandedLandingSlides': typeof InitializedCoBrandedLandingSlidesLazyRoute
  '/_initialized/compareAccounts': typeof InitializedCompareAccountsLazyRoute
  '/_initialized/confirmExit': typeof InitializedConfirmExitLazyRoute
  '/_initialized/confirmPasscode': typeof InitializedConfirmPasscodeLazyRoute
  '/_initialized/email': typeof InitializedEmailLazyRoute
  '/_initialized/existingCardDecision': typeof InitializedExistingCardDecisionLazyRoute
  '/_initialized/existingUserDecision': typeof InitializedExistingUserDecisionLazyRoute
  '/_initialized/fullName': typeof InitializedFullNameLazyRoute
  '/_initialized/kycFailed': typeof InitializedKycFailedLazyRoute
  '/_initialized/kycFailedEssentialAvailable': typeof InitializedKycFailedEssentialAvailableLazyRoute
  '/_initialized/kycMinor': typeof InitializedKycMinorLazyRoute
  '/_initialized/kycPending': typeof InitializedKycPendingLazyRoute
  '/_initialized/nameOnCard': typeof InitializedNameOnCardLazyRoute
  '/_initialized/needOrganizationLink': typeof InitializedNeedOrganizationLinkLazyRoute
  '/_initialized/noClaimLink': typeof InitializedNoClaimLinkLazyRoute
  '/_initialized/payCardEducation': typeof InitializedPayCardEducationLazyRoute
  '/_initialized/postLoginExistingUser': typeof InitializedPostLoginExistingUserLazyRoute
  '/_initialized/singleSignOn': typeof InitializedSingleSignOnLazyRoute
  '/_initialized/ssn': typeof InitializedSsnLazyRoute
  '/_initialized/address/addressPOBoxError': typeof InitializedAddressAddressPOBoxErrorRoute
  '/_initialized/address/addressRecommendation': typeof InitializedAddressAddressRecommendationRoute
  '/_initialized/phone/signInVerifyPin': typeof InitializedPhoneSignInVerifyPinRoute
  '/_initialized/phone/signUpVerifyPin': typeof InitializedPhoneSignUpVerifyPinRoute
  '/_initialized/address/addressSearch': typeof InitializedAddressAddressSearchLazyRoute
  '/_initialized/address/addressUpdateVerification': typeof InitializedAddressAddressUpdateVerificationLazyRoute
  '/_initialized/phone/existingUser': typeof InitializedPhoneExistingUserLazyRoute
  '/_initialized/phone/signInPhone': typeof InitializedPhoneSignInPhoneLazyRoute
  '/_initialized/address/': typeof InitializedAddressIndexRoute
  '/_initialized/phone/': typeof InitializedPhoneIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accountCreated'
    | '/accountTypeSelection'
    | '/activateCard'
    | '/activateExistingCard'
    | '/branchInformational'
    | '/businessAccountTypeSelection'
    | '/kycResults'
    | '/passcode'
    | '/persona'
    | '/setMarqetaPin'
    | '/terms'
    | '/verifyCardDetails'
    | '/verifyRosterMatch'
    | '/walletCreationOverview'
    | '/birthDate'
    | '/cardLastFour'
    | '/coBrandedLandingSlides'
    | '/compareAccounts'
    | '/confirmExit'
    | '/confirmPasscode'
    | '/email'
    | '/existingCardDecision'
    | '/existingUserDecision'
    | '/fullName'
    | '/kycFailed'
    | '/kycFailedEssentialAvailable'
    | '/kycMinor'
    | '/kycPending'
    | '/nameOnCard'
    | '/needOrganizationLink'
    | '/noClaimLink'
    | '/payCardEducation'
    | '/postLoginExistingUser'
    | '/singleSignOn'
    | '/ssn'
    | '/address/addressPOBoxError'
    | '/address/addressRecommendation'
    | '/phone/signInVerifyPin'
    | '/phone/signUpVerifyPin'
    | '/address/addressSearch'
    | '/address/addressUpdateVerification'
    | '/phone/existingUser'
    | '/phone/signInPhone'
    | '/address'
    | '/phone'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accountCreated'
    | '/accountTypeSelection'
    | '/activateCard'
    | '/activateExistingCard'
    | '/branchInformational'
    | '/businessAccountTypeSelection'
    | '/kycResults'
    | '/passcode'
    | '/persona'
    | '/setMarqetaPin'
    | '/terms'
    | '/verifyCardDetails'
    | '/verifyRosterMatch'
    | '/walletCreationOverview'
    | '/birthDate'
    | '/cardLastFour'
    | '/coBrandedLandingSlides'
    | '/compareAccounts'
    | '/confirmExit'
    | '/confirmPasscode'
    | '/email'
    | '/existingCardDecision'
    | '/existingUserDecision'
    | '/fullName'
    | '/kycFailed'
    | '/kycFailedEssentialAvailable'
    | '/kycMinor'
    | '/kycPending'
    | '/nameOnCard'
    | '/needOrganizationLink'
    | '/noClaimLink'
    | '/payCardEducation'
    | '/postLoginExistingUser'
    | '/singleSignOn'
    | '/ssn'
    | '/address/addressPOBoxError'
    | '/address/addressRecommendation'
    | '/phone/signInVerifyPin'
    | '/phone/signUpVerifyPin'
    | '/address/addressSearch'
    | '/address/addressUpdateVerification'
    | '/phone/existingUser'
    | '/phone/signInPhone'
    | '/address'
    | '/phone'
  id:
    | '__root__'
    | '/'
    | '/_initialized'
    | '/_initialized/accountCreated'
    | '/_initialized/accountTypeSelection'
    | '/_initialized/activateCard'
    | '/_initialized/activateExistingCard'
    | '/_initialized/branchInformational'
    | '/_initialized/businessAccountTypeSelection'
    | '/_initialized/kycResults'
    | '/_initialized/passcode'
    | '/_initialized/persona'
    | '/_initialized/setMarqetaPin'
    | '/_initialized/terms'
    | '/_initialized/verifyCardDetails'
    | '/_initialized/verifyRosterMatch'
    | '/_initialized/walletCreationOverview'
    | '/_initialized/birthDate'
    | '/_initialized/cardLastFour'
    | '/_initialized/coBrandedLandingSlides'
    | '/_initialized/compareAccounts'
    | '/_initialized/confirmExit'
    | '/_initialized/confirmPasscode'
    | '/_initialized/email'
    | '/_initialized/existingCardDecision'
    | '/_initialized/existingUserDecision'
    | '/_initialized/fullName'
    | '/_initialized/kycFailed'
    | '/_initialized/kycFailedEssentialAvailable'
    | '/_initialized/kycMinor'
    | '/_initialized/kycPending'
    | '/_initialized/nameOnCard'
    | '/_initialized/needOrganizationLink'
    | '/_initialized/noClaimLink'
    | '/_initialized/payCardEducation'
    | '/_initialized/postLoginExistingUser'
    | '/_initialized/singleSignOn'
    | '/_initialized/ssn'
    | '/_initialized/address/addressPOBoxError'
    | '/_initialized/address/addressRecommendation'
    | '/_initialized/phone/signInVerifyPin'
    | '/_initialized/phone/signUpVerifyPin'
    | '/_initialized/address/addressSearch'
    | '/_initialized/address/addressUpdateVerification'
    | '/_initialized/phone/existingUser'
    | '/_initialized/phone/signInPhone'
    | '/_initialized/address/'
    | '/_initialized/phone/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InitializedRoute: typeof InitializedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_initialized': {
      id: '/_initialized'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof InitializedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_initialized/ssn': {
      id: '/_initialized/ssn'
      path: '/ssn'
      fullPath: '/ssn'
      preLoaderRoute: typeof InitializedSsnLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/singleSignOn': {
      id: '/_initialized/singleSignOn'
      path: '/singleSignOn'
      fullPath: '/singleSignOn'
      preLoaderRoute: typeof InitializedSingleSignOnLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/postLoginExistingUser': {
      id: '/_initialized/postLoginExistingUser'
      path: '/postLoginExistingUser'
      fullPath: '/postLoginExistingUser'
      preLoaderRoute: typeof InitializedPostLoginExistingUserLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/payCardEducation': {
      id: '/_initialized/payCardEducation'
      path: '/payCardEducation'
      fullPath: '/payCardEducation'
      preLoaderRoute: typeof InitializedPayCardEducationLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/noClaimLink': {
      id: '/_initialized/noClaimLink'
      path: '/noClaimLink'
      fullPath: '/noClaimLink'
      preLoaderRoute: typeof InitializedNoClaimLinkLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/needOrganizationLink': {
      id: '/_initialized/needOrganizationLink'
      path: '/needOrganizationLink'
      fullPath: '/needOrganizationLink'
      preLoaderRoute: typeof InitializedNeedOrganizationLinkLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/nameOnCard': {
      id: '/_initialized/nameOnCard'
      path: '/nameOnCard'
      fullPath: '/nameOnCard'
      preLoaderRoute: typeof InitializedNameOnCardLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/kycPending': {
      id: '/_initialized/kycPending'
      path: '/kycPending'
      fullPath: '/kycPending'
      preLoaderRoute: typeof InitializedKycPendingLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/kycMinor': {
      id: '/_initialized/kycMinor'
      path: '/kycMinor'
      fullPath: '/kycMinor'
      preLoaderRoute: typeof InitializedKycMinorLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/kycFailedEssentialAvailable': {
      id: '/_initialized/kycFailedEssentialAvailable'
      path: '/kycFailedEssentialAvailable'
      fullPath: '/kycFailedEssentialAvailable'
      preLoaderRoute: typeof InitializedKycFailedEssentialAvailableLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/kycFailed': {
      id: '/_initialized/kycFailed'
      path: '/kycFailed'
      fullPath: '/kycFailed'
      preLoaderRoute: typeof InitializedKycFailedLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/fullName': {
      id: '/_initialized/fullName'
      path: '/fullName'
      fullPath: '/fullName'
      preLoaderRoute: typeof InitializedFullNameLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/existingUserDecision': {
      id: '/_initialized/existingUserDecision'
      path: '/existingUserDecision'
      fullPath: '/existingUserDecision'
      preLoaderRoute: typeof InitializedExistingUserDecisionLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/existingCardDecision': {
      id: '/_initialized/existingCardDecision'
      path: '/existingCardDecision'
      fullPath: '/existingCardDecision'
      preLoaderRoute: typeof InitializedExistingCardDecisionLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/email': {
      id: '/_initialized/email'
      path: '/email'
      fullPath: '/email'
      preLoaderRoute: typeof InitializedEmailLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/confirmPasscode': {
      id: '/_initialized/confirmPasscode'
      path: '/confirmPasscode'
      fullPath: '/confirmPasscode'
      preLoaderRoute: typeof InitializedConfirmPasscodeLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/confirmExit': {
      id: '/_initialized/confirmExit'
      path: '/confirmExit'
      fullPath: '/confirmExit'
      preLoaderRoute: typeof InitializedConfirmExitLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/compareAccounts': {
      id: '/_initialized/compareAccounts'
      path: '/compareAccounts'
      fullPath: '/compareAccounts'
      preLoaderRoute: typeof InitializedCompareAccountsLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/coBrandedLandingSlides': {
      id: '/_initialized/coBrandedLandingSlides'
      path: '/coBrandedLandingSlides'
      fullPath: '/coBrandedLandingSlides'
      preLoaderRoute: typeof InitializedCoBrandedLandingSlidesLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/cardLastFour': {
      id: '/_initialized/cardLastFour'
      path: '/cardLastFour'
      fullPath: '/cardLastFour'
      preLoaderRoute: typeof InitializedCardLastFourLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/birthDate': {
      id: '/_initialized/birthDate'
      path: '/birthDate'
      fullPath: '/birthDate'
      preLoaderRoute: typeof InitializedBirthDateLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/walletCreationOverview': {
      id: '/_initialized/walletCreationOverview'
      path: '/walletCreationOverview'
      fullPath: '/walletCreationOverview'
      preLoaderRoute: typeof InitializedWalletCreationOverviewRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/verifyRosterMatch': {
      id: '/_initialized/verifyRosterMatch'
      path: '/verifyRosterMatch'
      fullPath: '/verifyRosterMatch'
      preLoaderRoute: typeof InitializedVerifyRosterMatchRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/verifyCardDetails': {
      id: '/_initialized/verifyCardDetails'
      path: '/verifyCardDetails'
      fullPath: '/verifyCardDetails'
      preLoaderRoute: typeof InitializedVerifyCardDetailsRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/terms': {
      id: '/_initialized/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof InitializedTermsRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/setMarqetaPin': {
      id: '/_initialized/setMarqetaPin'
      path: '/setMarqetaPin'
      fullPath: '/setMarqetaPin'
      preLoaderRoute: typeof InitializedSetMarqetaPinRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/persona': {
      id: '/_initialized/persona'
      path: '/persona'
      fullPath: '/persona'
      preLoaderRoute: typeof InitializedPersonaRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/passcode': {
      id: '/_initialized/passcode'
      path: '/passcode'
      fullPath: '/passcode'
      preLoaderRoute: typeof InitializedPasscodeRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/kycResults': {
      id: '/_initialized/kycResults'
      path: '/kycResults'
      fullPath: '/kycResults'
      preLoaderRoute: typeof InitializedKycResultsRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/businessAccountTypeSelection': {
      id: '/_initialized/businessAccountTypeSelection'
      path: '/businessAccountTypeSelection'
      fullPath: '/businessAccountTypeSelection'
      preLoaderRoute: typeof InitializedBusinessAccountTypeSelectionRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/branchInformational': {
      id: '/_initialized/branchInformational'
      path: '/branchInformational'
      fullPath: '/branchInformational'
      preLoaderRoute: typeof InitializedBranchInformationalRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/activateExistingCard': {
      id: '/_initialized/activateExistingCard'
      path: '/activateExistingCard'
      fullPath: '/activateExistingCard'
      preLoaderRoute: typeof InitializedActivateExistingCardRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/activateCard': {
      id: '/_initialized/activateCard'
      path: '/activateCard'
      fullPath: '/activateCard'
      preLoaderRoute: typeof InitializedActivateCardRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/accountTypeSelection': {
      id: '/_initialized/accountTypeSelection'
      path: '/accountTypeSelection'
      fullPath: '/accountTypeSelection'
      preLoaderRoute: typeof InitializedAccountTypeSelectionRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/accountCreated': {
      id: '/_initialized/accountCreated'
      path: '/accountCreated'
      fullPath: '/accountCreated'
      preLoaderRoute: typeof InitializedAccountCreatedRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/phone/': {
      id: '/_initialized/phone/'
      path: '/phone'
      fullPath: '/phone'
      preLoaderRoute: typeof InitializedPhoneIndexLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/address/': {
      id: '/_initialized/address/'
      path: '/address'
      fullPath: '/address'
      preLoaderRoute: typeof InitializedAddressIndexRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/phone/signInPhone': {
      id: '/_initialized/phone/signInPhone'
      path: '/phone/signInPhone'
      fullPath: '/phone/signInPhone'
      preLoaderRoute: typeof InitializedPhoneSignInPhoneLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/phone/existingUser': {
      id: '/_initialized/phone/existingUser'
      path: '/phone/existingUser'
      fullPath: '/phone/existingUser'
      preLoaderRoute: typeof InitializedPhoneExistingUserLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/address/addressUpdateVerification': {
      id: '/_initialized/address/addressUpdateVerification'
      path: '/address/addressUpdateVerification'
      fullPath: '/address/addressUpdateVerification'
      preLoaderRoute: typeof InitializedAddressAddressUpdateVerificationLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/address/addressSearch': {
      id: '/_initialized/address/addressSearch'
      path: '/address/addressSearch'
      fullPath: '/address/addressSearch'
      preLoaderRoute: typeof InitializedAddressAddressSearchLazyRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/phone/signUpVerifyPin': {
      id: '/_initialized/phone/signUpVerifyPin'
      path: '/phone/signUpVerifyPin'
      fullPath: '/phone/signUpVerifyPin'
      preLoaderRoute: typeof InitializedPhoneSignUpVerifyPinRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/phone/signInVerifyPin': {
      id: '/_initialized/phone/signInVerifyPin'
      path: '/phone/signInVerifyPin'
      fullPath: '/phone/signInVerifyPin'
      preLoaderRoute: typeof InitializedPhoneSignInVerifyPinRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/address/addressRecommendation': {
      id: '/_initialized/address/addressRecommendation'
      path: '/address/addressRecommendation'
      fullPath: '/address/addressRecommendation'
      preLoaderRoute: typeof InitializedAddressAddressRecommendationRouteImport
      parentRoute: typeof InitializedRoute
    }
    '/_initialized/address/addressPOBoxError': {
      id: '/_initialized/address/addressPOBoxError'
      path: '/address/addressPOBoxError'
      fullPath: '/address/addressPOBoxError'
      preLoaderRoute: typeof InitializedAddressAddressPOBoxErrorRouteImport
      parentRoute: typeof InitializedRoute
    }
  }
}

interface InitializedRouteChildren {
  InitializedAccountCreatedRoute: typeof InitializedAccountCreatedRoute
  InitializedAccountTypeSelectionRoute: typeof InitializedAccountTypeSelectionRoute
  InitializedActivateCardRoute: typeof InitializedActivateCardRoute
  InitializedActivateExistingCardRoute: typeof InitializedActivateExistingCardRoute
  InitializedBranchInformationalRoute: typeof InitializedBranchInformationalRoute
  InitializedBusinessAccountTypeSelectionRoute: typeof InitializedBusinessAccountTypeSelectionRoute
  InitializedKycResultsRoute: typeof InitializedKycResultsRoute
  InitializedPasscodeRoute: typeof InitializedPasscodeRoute
  InitializedPersonaRoute: typeof InitializedPersonaRoute
  InitializedSetMarqetaPinRoute: typeof InitializedSetMarqetaPinRoute
  InitializedTermsRoute: typeof InitializedTermsRoute
  InitializedVerifyCardDetailsRoute: typeof InitializedVerifyCardDetailsRoute
  InitializedVerifyRosterMatchRoute: typeof InitializedVerifyRosterMatchRoute
  InitializedWalletCreationOverviewRoute: typeof InitializedWalletCreationOverviewRoute
  InitializedBirthDateLazyRoute: typeof InitializedBirthDateLazyRoute
  InitializedCardLastFourLazyRoute: typeof InitializedCardLastFourLazyRoute
  InitializedCoBrandedLandingSlidesLazyRoute: typeof InitializedCoBrandedLandingSlidesLazyRoute
  InitializedCompareAccountsLazyRoute: typeof InitializedCompareAccountsLazyRoute
  InitializedConfirmExitLazyRoute: typeof InitializedConfirmExitLazyRoute
  InitializedConfirmPasscodeLazyRoute: typeof InitializedConfirmPasscodeLazyRoute
  InitializedEmailLazyRoute: typeof InitializedEmailLazyRoute
  InitializedExistingCardDecisionLazyRoute: typeof InitializedExistingCardDecisionLazyRoute
  InitializedExistingUserDecisionLazyRoute: typeof InitializedExistingUserDecisionLazyRoute
  InitializedFullNameLazyRoute: typeof InitializedFullNameLazyRoute
  InitializedKycFailedLazyRoute: typeof InitializedKycFailedLazyRoute
  InitializedKycFailedEssentialAvailableLazyRoute: typeof InitializedKycFailedEssentialAvailableLazyRoute
  InitializedKycMinorLazyRoute: typeof InitializedKycMinorLazyRoute
  InitializedKycPendingLazyRoute: typeof InitializedKycPendingLazyRoute
  InitializedNameOnCardLazyRoute: typeof InitializedNameOnCardLazyRoute
  InitializedNeedOrganizationLinkLazyRoute: typeof InitializedNeedOrganizationLinkLazyRoute
  InitializedNoClaimLinkLazyRoute: typeof InitializedNoClaimLinkLazyRoute
  InitializedPayCardEducationLazyRoute: typeof InitializedPayCardEducationLazyRoute
  InitializedPostLoginExistingUserLazyRoute: typeof InitializedPostLoginExistingUserLazyRoute
  InitializedSingleSignOnLazyRoute: typeof InitializedSingleSignOnLazyRoute
  InitializedSsnLazyRoute: typeof InitializedSsnLazyRoute
  InitializedAddressAddressPOBoxErrorRoute: typeof InitializedAddressAddressPOBoxErrorRoute
  InitializedAddressAddressRecommendationRoute: typeof InitializedAddressAddressRecommendationRoute
  InitializedPhoneSignInVerifyPinRoute: typeof InitializedPhoneSignInVerifyPinRoute
  InitializedPhoneSignUpVerifyPinRoute: typeof InitializedPhoneSignUpVerifyPinRoute
  InitializedAddressAddressSearchLazyRoute: typeof InitializedAddressAddressSearchLazyRoute
  InitializedAddressAddressUpdateVerificationLazyRoute: typeof InitializedAddressAddressUpdateVerificationLazyRoute
  InitializedPhoneExistingUserLazyRoute: typeof InitializedPhoneExistingUserLazyRoute
  InitializedPhoneSignInPhoneLazyRoute: typeof InitializedPhoneSignInPhoneLazyRoute
  InitializedAddressIndexRoute: typeof InitializedAddressIndexRoute
  InitializedPhoneIndexLazyRoute: typeof InitializedPhoneIndexLazyRoute
}

const InitializedRouteChildren: InitializedRouteChildren = {
  InitializedAccountCreatedRoute: InitializedAccountCreatedRoute,
  InitializedAccountTypeSelectionRoute: InitializedAccountTypeSelectionRoute,
  InitializedActivateCardRoute: InitializedActivateCardRoute,
  InitializedActivateExistingCardRoute: InitializedActivateExistingCardRoute,
  InitializedBranchInformationalRoute: InitializedBranchInformationalRoute,
  InitializedBusinessAccountTypeSelectionRoute:
    InitializedBusinessAccountTypeSelectionRoute,
  InitializedKycResultsRoute: InitializedKycResultsRoute,
  InitializedPasscodeRoute: InitializedPasscodeRoute,
  InitializedPersonaRoute: InitializedPersonaRoute,
  InitializedSetMarqetaPinRoute: InitializedSetMarqetaPinRoute,
  InitializedTermsRoute: InitializedTermsRoute,
  InitializedVerifyCardDetailsRoute: InitializedVerifyCardDetailsRoute,
  InitializedVerifyRosterMatchRoute: InitializedVerifyRosterMatchRoute,
  InitializedWalletCreationOverviewRoute:
    InitializedWalletCreationOverviewRoute,
  InitializedBirthDateLazyRoute: InitializedBirthDateLazyRoute,
  InitializedCardLastFourLazyRoute: InitializedCardLastFourLazyRoute,
  InitializedCoBrandedLandingSlidesLazyRoute:
    InitializedCoBrandedLandingSlidesLazyRoute,
  InitializedCompareAccountsLazyRoute: InitializedCompareAccountsLazyRoute,
  InitializedConfirmExitLazyRoute: InitializedConfirmExitLazyRoute,
  InitializedConfirmPasscodeLazyRoute: InitializedConfirmPasscodeLazyRoute,
  InitializedEmailLazyRoute: InitializedEmailLazyRoute,
  InitializedExistingCardDecisionLazyRoute:
    InitializedExistingCardDecisionLazyRoute,
  InitializedExistingUserDecisionLazyRoute:
    InitializedExistingUserDecisionLazyRoute,
  InitializedFullNameLazyRoute: InitializedFullNameLazyRoute,
  InitializedKycFailedLazyRoute: InitializedKycFailedLazyRoute,
  InitializedKycFailedEssentialAvailableLazyRoute:
    InitializedKycFailedEssentialAvailableLazyRoute,
  InitializedKycMinorLazyRoute: InitializedKycMinorLazyRoute,
  InitializedKycPendingLazyRoute: InitializedKycPendingLazyRoute,
  InitializedNameOnCardLazyRoute: InitializedNameOnCardLazyRoute,
  InitializedNeedOrganizationLinkLazyRoute:
    InitializedNeedOrganizationLinkLazyRoute,
  InitializedNoClaimLinkLazyRoute: InitializedNoClaimLinkLazyRoute,
  InitializedPayCardEducationLazyRoute: InitializedPayCardEducationLazyRoute,
  InitializedPostLoginExistingUserLazyRoute:
    InitializedPostLoginExistingUserLazyRoute,
  InitializedSingleSignOnLazyRoute: InitializedSingleSignOnLazyRoute,
  InitializedSsnLazyRoute: InitializedSsnLazyRoute,
  InitializedAddressAddressPOBoxErrorRoute:
    InitializedAddressAddressPOBoxErrorRoute,
  InitializedAddressAddressRecommendationRoute:
    InitializedAddressAddressRecommendationRoute,
  InitializedPhoneSignInVerifyPinRoute: InitializedPhoneSignInVerifyPinRoute,
  InitializedPhoneSignUpVerifyPinRoute: InitializedPhoneSignUpVerifyPinRoute,
  InitializedAddressAddressSearchLazyRoute:
    InitializedAddressAddressSearchLazyRoute,
  InitializedAddressAddressUpdateVerificationLazyRoute:
    InitializedAddressAddressUpdateVerificationLazyRoute,
  InitializedPhoneExistingUserLazyRoute: InitializedPhoneExistingUserLazyRoute,
  InitializedPhoneSignInPhoneLazyRoute: InitializedPhoneSignInPhoneLazyRoute,
  InitializedAddressIndexRoute: InitializedAddressIndexRoute,
  InitializedPhoneIndexLazyRoute: InitializedPhoneIndexLazyRoute,
}

const InitializedRouteWithChildren = InitializedRoute._addFileChildren(
  InitializedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InitializedRoute: InitializedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
